import { useState, useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { MapLink, MapLinkText } from '../styled';
import { fromObjToUrl } from '../../../../utils/helpers';
import { RAILS_ROUTES } from '../../../../utils/helpers/constants';
import { getMapUrl } from '../../../../utils/helpers/search';
import { modifyUrlForLanguage } from '../../../../utils/helpers/modifyUrlForLanguage';
import { getLocalDataQuery } from '../../../../api/queries';
import { LocalDataQuery } from '../../../../graphql/graphql';
import { selectSearchFormCurrentState } from '../../../../store/selectors';
import Icon from '../../../Icon';
import MapIcon from '../../../../public/static/images/new_search/icons/map-icon.svg';

export const MapButton = () => {
  const {
    t,
    i18n: { language }
  } = useTranslation();
  const router = useRouter();
  const { url, ...queryObj } = router.query;
  const storedFormState = useSelector(selectSearchFormCurrentState);
  const [mapUrl, setMapUrl] = useState<string | null>(null);
  const client = useApolloClient();

  useEffect(() => {
    const prepareMapUrl = async () => {
      try {
        const localData: { data: LocalDataQuery } = await client.query({
          query: getLocalDataQuery,
          variables: { id: storedFormState.city_id }
        });

        const { as } = fromObjToUrl(
          storedFormState,
          localData.data,
          queryObj.sorting
        );

        setMapUrl(getMapUrl(as));
      } catch (error) {
        console.error('Error fetching map URL:', error);
      }
    };

    if (storedFormState.city_id) {
      prepareMapUrl();
    }
  }, [client, storedFormState.city_id, storedFormState, queryObj.sorting]);

  return (
    <MapLink
      href={modifyUrlForLanguage(mapUrl || RAILS_ROUTES.MAP, language)}
      target="_blank"
      rel="noopener noreferrer"
      data-cy="new-search-map-link"
      data-stat="new-search-map-link"
    >
      <Icon IconComponent={MapIcon} width={20} height={20} indent={false} />
      <MapLinkText tag="body_1">{t('new_search.map')}</MapLinkText>
    </MapLink>
  );
};
